import React from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import { MDBIcon } from "mdbreact";
import "./shared.scss";
import CircularProgress from "@material-ui/core/CircularProgress";
import Chip from "@material-ui/core/Chip";
import BasicButton from "../../components/SharedComponents/BasicButton/BasicButton";
import TableFilters from "./TableFilters";
import TableInlineEdits from "./TableInlineEdits";
import _ from "lodash";
import BasicTextField from "./BasicTextField/BasicTextField";
import { withUserContext } from "../../contexts/UserContext";
// import BasicCheckbox from "./BasicCheckbox/BasicCheckbox";

class TableComponent extends React.Component {
  constructor(props) {
    super(props);
    var headings = this.props?.config?.headings;
    var colArr = {};
    var dataTypeArr = {};
    var selectOptionsArr = {};
    headings.forEach((heading, index) => {
      colArr[heading.headingLabel] = "";
      dataTypeArr[this.props?.config?.dataNodes[index]] = heading.inputType;
      if (["select", "searchselect", "searchselectid"].includes(heading.inputType))
        selectOptionsArr[this.props?.config?.dataNodes[index]] =
          heading.selectOptions;
    });
    this.props?.config?.detailFields?.forEach((field) => {
      dataTypeArr[field.dataNode] = field.inputType;
      selectOptionsArr[field.dataNode] = field.selectOptions;
    });
    this.state = {
      detailsAnchor: null,
      detailsRowIndex: null,
      inputValues: colArr,
      filterValues: [],
      listEdits: JSON.parse(JSON.stringify(this.props?.list || [])),
      editInputValues: [],
      dataTypeValues: dataTypeArr,
      selectOptionValues: selectOptionsArr,
      dropDownValues: [],
    };
  }

  componentDidMount() {
    //var headings = this.props?.config?.headings;
    // var colArr = {};
    // var dataTypeArr = {};
    // var selectOptionsArr = {};
    // headings.forEach((heading) => {
    //     colArr[heading.headingLabel] = "";
    //     dataTypeArr[this.props?.config?.dataNodes[index]] = heading.inputType ;
    //     if(heading.inputType == "select")
    //     selectOptionsArr[this.props?.config?.dataNodes[index]] = heading.selectOptions;
    // });
    // this.setState({
    //     inputValues : colArr,
    //     filterValues: [],
    //     listEdits: JSON.parse(JSON.stringify(this.props?.list || [])),
    //     dataTypeValues: dataTypeArr,
    //     selectOptionValues: selectOptionsArr
    // });
    let newInputValues = { ...this.state.newItem };
    newInputValues["currency_exchange"] = this.props?.defaultCompanyCurrency;
    newInputValues["actual_cost"] = this.props?.actualCost
    newInputValues["rush"] = this.props?.rush;
    this.setState({ newItem: newInputValues});
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.list !== this.props.list) {
      this.setState({
        listEdits: JSON.parse(JSON.stringify(this.props?.list || [])),
      });
    }
    if(prevProps.actualCost !== this.props.actualCost){
      let newInputValues = { ...this.state.newItem };
      newInputValues["actual_cost"] = this.props?.actualCost;
        this.setState({ newItem: newInputValues})
    }
    if(prevProps.rush !== this.props.rush || (prevProps.rush === this.props.rush && prevProps.list !== this.props.list)){
      let newInputValues = { ...this.state.newItem };
      newInputValues["rush"] = this.props?.rush;
      this.setState({ newItem: newInputValues})
    }
    if (prevProps.defaultCompanyExchangeRate !== this.props.defaultCompanyExchangeRate) {      
      this.setState({
        newItem: {
          quantity: null,
          subtotal: null,
          subtotal_value: null,
          total_cost: null,
          total_cost_value: null,
          unit_cost: null,         
        }
      },()=>{
        let newInputValues = { ...this.state.newItem };
      newInputValues["currency_exchange"] = this.props?.defaultCompanyCurrency;
        this.setState({ newItem: newInputValues})
      });
    }
    let selectOptionsArr = { ...this.state.selectOptionValues };
    let selectOptionsChanged = false;
    this.props?.config?.headings?.map((heading, index) => {
      if (["select", "searchselect", "searchselectid"].includes(heading.inputType)) {
        if (
          this.state.selectOptionValues[this.props?.config.dataNodes[index]] !==
          heading.selectOptions
        ) {
          selectOptionsArr[this.props?.config?.dataNodes[index]] =
            heading.selectOptions;
          selectOptionsChanged = true;
        }
      }
    });
    this.props?.config?.detailFields?.forEach((field) => {
      if (this.state.selectOptionValues[field.dataNode] !== field.selectOptions) {
        selectOptionsArr[field.dataNode] = field.selectOptions;
        selectOptionsChanged = true;
      }
    });
    if (selectOptionsChanged) {
      this.setState({ selectOptionValues: selectOptionsArr });
    }
  }

  getInputType = (dataNode) => {
    const inputType = this.state.dataTypeValues[dataNode];
    const limit = this.props?.config?.searchSelectAbove;
    return limit &&
      inputType === "select" &&
      (this.state.selectOptionValues?.[dataNode]?.length || 0) > limit
      ? "searchselectid"
      : inputType;
  };

  openLineDetails = (e, rowIndex) => {
    this.setState({ detailsAnchor: e.currentTarget, detailsRowIndex: rowIndex });
  };

  closeLineDetails = () => {
    this.setState({ detailsAnchor: null, detailsRowIndex: null });
  };

  getDetailDisplayValue = (field, value) => {
    const options = this.state.selectOptionValues?.[field.dataNode];
    if (!options) return value || "-";
    const labelOf = (item) => options.find((option) => option.value === item)?.label;
    const labels = (Array.isArray(value) ? value : [value]).map(labelOf).filter(Boolean);
    return labels.length > 0 ? labels.join(", ") : "-";
  };

  renderLineDetailsButton = (rowIndex) => (
    <Tooltip title="More details" placement="left">
      <Button
        className="table-info-button"
        onClick={(e) => this.openLineDetails(e, rowIndex)}
      >
        <MDBIcon icon="expand-alt" className="action-icon" />
      </Button>
    </Tooltip>
  );

  renderAddItemActions = (addButtons) =>
    this.props?.config?.detailFields ? (
      <div className="line-details-new">
        {addButtons}
        {this.renderLineDetailsButton("new")}
      </div>
    ) : (
      addButtons
    );

  renderLineDetails = () => {
    const rowIndex = this.state.detailsRowIndex;
    const isNewItem = rowIndex === "new";
    const isEditing = isNewItem || this.props?.list?.[rowIndex]?.editing;
    const item = isNewItem
      ? this.state.newItem
      : isEditing
      ? this.state.listEdits?.[rowIndex]
      : this.props?.list?.[rowIndex];
    return (
      <Popover
        className="line-details-popover"
        open={Boolean(this.state.detailsAnchor)}
        anchorEl={this.state.detailsAnchor}
        onClose={this.closeLineDetails}
        disableEnforceFocus
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <div className="line-details">
          {this.props.config.detailFields.map((field) => {
            const value = item?.[field.dataNode] === "null" ? null : item?.[field.dataNode];
            return (
              <div
                className="line-details-field"
                style={{ gridColumn: field.colSpan ? `span ${field.colSpan}` : "1 / -1" }}
                key={field.dataNode}
              >
                <div className="line-details-label">{field.label}</div>
                {isEditing ? (
                  <TableInlineEdits
                    nodeName={field.dataNode}
                    placeholder={field.placeholder || "Select"}
                    inputType={this.getInputType(field.dataNode)}
                    inputValue={value}
                    width="100%"
                    index={isNewItem ? 0 : rowIndex}
                    handleInlineEditChange={
                      isNewItem ? this.onChangeNewItemHandler : this.handleInlineEditChange
                    }
                    selectOptions={this.state.selectOptionValues?.[field.dataNode]}
                    searchString={this.props?.searchString}
                  />
                ) : (
                  <div className="line-details-value">
                    {this.getDetailDisplayValue(field, value)}
                  </div>
                )}
              </div>
            );
          })}
          <div className="line-details-actions">
            <Button className="table-info-button" onClick={this.closeLineDetails}>
              <MDBIcon icon="times" className="action-icon" />
            </Button>
          </div>
        </div>
      </Popover>
    );
  };

  addFilterChangeHandler = (index, name, type, value) => {
    var inputValues = this.state.inputValues;
    var filterValues = this.state.filterValues;
    var dropDownValues = this.state.dropDownValues;
    if (type === "dropdown") {
      const dropDownValue = { value: inputValues[name], label: value };
      dropDownValues.push(dropDownValue);
    } else if (type === "autocomplete") {
      const dropDownValue = { value: inputValues[name].value, label: value };
      dropDownValues.push(dropDownValue);
    }
    if (filterValues.length > 0) {
      let presentInd = filterValues.findIndex(
        (item) => item.split(":")[0] === name
      );
      if (presentInd != -1) {
        if (type === "daterange") {
          if (inputValues[name] != "") {
            filterValues[presentInd] =
              name + ": " + value + " : " + inputValues[name];
          }
        } else {
          filterValues[presentInd] = name + ": " + value;
        }
      } else {
        if (type === "daterange") {
          if (inputValues[name] != "") {
            filterValues.push(name + ": " + value + " : " + inputValues[name]);
          }
        } else {
          filterValues.push(name + ": " + value);
        }
      }
    } else {
      if (type === "daterange") {
        if (inputValues[name] != "") {
          filterValues.push(name + ": " + value + " : " + inputValues[name]);
        }
      } else {
        filterValues.push(name + ": " + value);
      }
    }
    inputValues[name] = "";
    this.setState({
      inputValues: inputValues,
      filterValues: filterValues,
      dropDownValues: dropDownValues,
    });
    var filtersNone = false;
    if (filterValues.length == 0) filtersNone = true;
    this.props.applyFilter(filterValues, filtersNone, dropDownValues);
  };

  filterChangeHandler = (index, name, value, filter) => {
    var inputValues = this.state.inputValues;
    inputValues[name] = value;
    this.setState({
      inputValues: inputValues,
    });
  };

  onChangeNewItemHandler = (value, index, nodeName) => {
    if(this.props?.config?.isHboTenant?.[0]==="HBO" || this.props?.config?.tenantName?.[0]==="ContentAcquisition"){
      this.onChangeNewItemHandlerForHBOTenant(value, index, nodeName);
    }else{
    let newInputValues = { ...this.state.newItem };
    newInputValues[nodeName] = value;
    if (
      this.props.autoCalculate &&
      ["quantity", "unit_cost", "currency_exchange"].includes(nodeName)
    ) {
      if (newInputValues["quantity"] && newInputValues["unit_cost"]) {
        newInputValues["subtotal"] =
          newInputValues["quantity"] * newInputValues["unit_cost"];
        newInputValues["subtotal"] = Number.parseFloat(
          newInputValues["subtotal"]
        ).toFixed(2);
        newInputValues["subtotal_value"] = newInputValues["subtotal"];
      }
      if (newInputValues["subtotal"]) {
        let currency = _.find(this.props.currencies, {
          currency_exchange: newInputValues["currency_exchange"],
        });
        // if (currency) {
        // If exchange_rate is not selected, then consider as 1
        newInputValues["total_cost"] =
        newInputValues["subtotal"] * (currency?.exchange_rate || (this.props?.defaultCompanyExchangeRate ?? 1));
        newInputValues["total_cost"] = Number.parseFloat(
          newInputValues["total_cost"]
        ).toFixed(2);
        newInputValues["total_cost_value"] = newInputValues["total_cost"];
        // }
      }
    }
    this.setState({ newItem: newInputValues});
  }
}


  onChangeNewItemHandlerForHBOTenant = (value, index, nodeName) => {
    let newInputValues = { ...this.state.newItem };
    newInputValues[nodeName] = value;   
    if(nodeName==='actual_cost'){
      this.props?.updateActualCost(value);
    }else if(nodeName==='rush'){
      this.props?.updateRush(value);
    }else{
    if (
      this.props.autoCalculate &&
      ["quantity", "unit_cost", "currency_exchange","adj_curr_exch_rate","currency_code"].includes(nodeName)
    ) {
      if (newInputValues["quantity"] && newInputValues["unit_cost"]) {
        newInputValues["subtotal"] =
          newInputValues["quantity"] * newInputValues["unit_cost"];
        newInputValues["subtotal"] = Number.parseFloat(
          newInputValues["subtotal"]
        ).toFixed(2);
        newInputValues["subtotal_value"] = newInputValues["subtotal"];
      }else{
        newInputValues["subtotal"] = true;
      }
      
      if(nodeName==="unit_cost" && !newInputValues["unit_cost"] || (nodeName==="quantity" && !newInputValues["quantity"])){
        newInputValues["total_cost"] =0;
        newInputValues["subtotal"] = 0;
        newInputValues["total_cost_value"] = 0;
      }
      

      let currency = _.find(this.props.currencies, (currency) => {        
        return currency.currency_code === (newInputValues["currency_code"]);
    });    
      if (newInputValues["subtotal"] ) {       
        if(nodeName === 'adj_curr_exch_rate'){
          newInputValues["total_cost"] =
          newInputValues["subtotal"] * (newInputValues[nodeName]!=null ? newInputValues[nodeName] : currency?.exchange_rate);
          newInputValues["currency_exchange"]=value;
          newInputValues["adj_currency_id"]=currency?.currency_id;
        }else if(nodeName === 'currency_code'){
          newInputValues["total_cost"] =
          newInputValues["subtotal"] * ( currency?.exchange_rate > 0 ?   currency?.exchange_rate: 1);
          newInputValues["adj_curr_exch_rate"]= ( currency?.exchange_rate > 0 ?   currency?.exchange_rate: 1);
          newInputValues["adj_currency_id"]=currency?.currency_id;
          newInputValues["currency_exchange"]=currency?.exchange_rate;
        }else{
          newInputValues["total_cost"] =
          newInputValues["subtotal"] * ((newInputValues["adj_curr_exch_rate"] ?? currency?.exchange_rate) ?? 1);
          newInputValues["adj_curr_exch_rate"]=newInputValues["adj_curr_exch_rate"] ?? currency?.exchange_rate ;
          newInputValues["adj_currency_id"]=currency?.currency_id;
          newInputValues["currency_exchange"]=currency?.exchange_rate;
        }     
        newInputValues["total_cost"] = Number.parseFloat(
          newInputValues["total_cost"]
        ).toFixed(2);
        newInputValues["total_cost_value"] = newInputValues["total_cost"];
        // }
      }else{
        newInputValues["subtotal_value"]  = newInputValues["total_cost_value"] = newInputValues["total_cost"] = newInputValues["subtotal"] =Number.parseFloat(
          0
        ).toFixed(2);
      }
    }
    this.setState({ newItem: newInputValues});  
  }  
  };

  handleAddNewItem = () => {
    this.props?.handleAddNewItem(this.state.newItem);
    if (this.props?.config?.isClearFields) {
      this.setState({ newItem: {} });
    }
  };

  handleInlineEditChange = (value, index, nodeName, type = null) => {
    if(this.props?.config?.isHboTenant?.[0]==="HBO" || this.props?.config?.tenantName?.[0]==="ContentAcquisition"){
      this.handleInlineEditChangeForHBO(value, index, nodeName, type );
    }else{
    var editInputValues = [...this.state.listEdits];
    editInputValues[index][nodeName] = value;
    if (
      this.props.autoCalculate &&
      ["quantity", "unit_cost", "currency_exchange"].includes(nodeName)
    ) {
      editInputValues[index].subtotal =
        editInputValues[index].quantity * editInputValues[index]?.unit_cost;
      editInputValues[index].subtotal = Number.parseFloat(
        editInputValues[index].subtotal
      ).toFixed(2);
      editInputValues[index].subtotal_value = editInputValues[index].subtotal;
      let currency = _.find(this.props.currencies, {
        currency_exchange: editInputValues[index].currency_exchange,
      });
      // if (currency) {
      // If exchange_rate is not selected, then consider as 1
      editInputValues[index].total_cost =
        editInputValues[index]?.subtotal * (currency?.exchange_rate || 1);
      editInputValues[index].total_cost = Number.parseFloat(
        editInputValues[index].total_cost
      ).toFixed(2);
      editInputValues[index].total_cost_value =
        editInputValues[index].total_cost;
      // }
    }
    this.setState({ listEdits: editInputValues }, () => {
      this.props?.checkUpdatedValues
        ? this.props?.checkUpdatedValues(this.state.listEdits, index)
        : null;
    });
  }
}

  handleInlineEditChangeForHBO = (value, index, nodeName, type) => {
    var editInputValues = [...this.state.listEdits];
    editInputValues[index][nodeName] = value;
    if (
      this.props.autoCalculate &&
      ["quantity", "unit_cost", "currency_exchange","adj_curr_exch_rate","currency_code"].includes(nodeName)
    ) {
      editInputValues[index].subtotal =
      Number.parseFloat( editInputValues[index].quantity * editInputValues[index]?.unit_cost).toFixed(2);
      
      
      editInputValues[index].subtotal_value = editInputValues[index].subtotal;
      let currency = _.find(this.props.currencies, {
        currency_code: editInputValues[index].currency_code,
      });
      // if (currency) {
      // If exchange_rate is not selected, then consider as 1
      if(nodeName === 'adj_curr_exch_rate'){
        editInputValues[index].total_cost =
        editInputValues[index]?.subtotal * (value || 1);
        editInputValues[index]["currency_exchange"]=value;
        editInputValues[index]["adj_currency_id"]=currency?.currency_id;
      }else if(nodeName === 'currency_code'){
        editInputValues[index].total_cost =
        editInputValues[index]?.subtotal * (currency?.exchange_rate > 0 ? currency?.exchange_rate : 1);
        editInputValues[index]["adj_curr_exch_rate"]= (currency?.exchange_rate > 0 ? currency?.exchange_rate : 1);
        editInputValues[index]["adj_currency_id"]= currency?.currency_id;
        editInputValues[index]["currency_exchange"]= currency?.exchange_rate;
      }
      else{
        editInputValues[index].total_cost =
        editInputValues[index]?.subtotal * ((editInputValues[index]["adj_curr_exch_rate"] ?? currency?.exchange_rate) || 1);
        editInputValues[index]["adj_curr_exch_rate"]=editInputValues[index]["adj_curr_exch_rate"] ?? currency?.exchange_rate;
        editInputValues[index]["adj_currency_id"]=currency?.currency_id;
        editInputValues[index]["currency_exchange"]=currency?.exchange_rate;
      }
     
      editInputValues[index].total_cost = Number.parseFloat(
        editInputValues[index].total_cost
      ).toFixed(2);
      editInputValues[index].total_cost_value =
        editInputValues[index].total_cost;
      // }
    }
    this.setState({ listEdits: editInputValues }, () => {
      this.props?.checkUpdatedValues
        ? this.props?.checkUpdatedValues(this.state.listEdits, index)
        : null;
    });
  };

  handleFilterDelete = (removeNode, index) => {
    var filterValues = this.state.filterValues;
    filterValues.splice(index, 1);
    this.setState({ filterValues: filterValues });
    var filtersNone = false;
    if (filterValues.length == 0) filtersNone = true;
    this.props.applyFilter(filterValues, filtersNone);
  };

  clearFilter = () => {
    this.setState({ filterValues: [] });
    this.props.clearFilterHandler();
  };
  render() {
    return (
      <>
        <div>
          {this.props?.config?.filters && (
            <>
              <div
                style={{ display: "flex" }}
                className="columnFilters mb-1 p-0"
              >
                {this.state.filterValues &&
                  this.state.filterValues?.map((item, index) => (
                    <Chip
                      label={item}
                      onDelete={this.handleFilterDelete.bind(this, item, index)}
                    />
                  ))}
                <div style={{ marginLeft: "auto" }}>
                  <BasicButton
                    type="inline"
                    variant="outlined"
                    icon=""
                    text="Clear Filters"
                    onClick={() => this.clearFilter()}
                  />
                </div>
              </div>

              <div class="filters-container d-flex flex-wrap p-2 bgColorWhite mb-2">
                {this.props?.config?.filters?.map((heading, index) => (
                  <div style={{ width: heading?.width }}>
                    <TableFilters
                      inputType={heading.inputType}
                      name={heading.headingLabel}
                      placeholder={heading.placeholder}
                      inputValue={this.state.inputValues[heading.headingLabel]}
                      options={this.props?.options[heading?.selectOptions]}
                      filterChangeHandler={this.filterChangeHandler.bind(
                        this,
                        index,
                        heading.headingLabel
                      )}
                      addFilterChangeHandler={this.addFilterChangeHandler.bind(
                        this,
                        index,
                        heading.headingLabel,
                        heading.inputType
                      )}
                    />{" "}
                  </div>
                ))}
              </div>
            </>
          )}

          <div
            className={
              this.props?.maxHeight
                ? "tableContainer " + "max-height-" + this.props?.maxHeight
                : "tableContainer"
            }
          >
            <TableContainer
              component={Paper}
              className={
                this.props?.tableMode == "light"
                  ? "bg-white overflow-x-unset"
                  : "bg-light overflow-x-unset"
              }
            >
              <Table
                id={this.props.className + "-table"}
                //stickyHeader
                aria-label="collapsible table"
                size="small"
                style={{ tableLayout: "fixed" }}
              >
                <colgroup>
                  {this.props?.config?.headings?.map((heading, index) => (
                    <col
                      key={"colWidth_" + index}
                      width={
                        heading.width
                          ? heading.width
                          : 100 / this.props?.config?.headings?.length + "%"
                      }
                    />
                  ))}
                </colgroup>
                {this.props?.config?.isSearchBar ? (
                  <>
                    <TableHead class="searchHeaders">
                      <TableRow key={this.props.className + "-searchHeaderRow"}>
                        {this.props?.config?.headings?.map((heading, index) => (
                          <TableCell
                            key={
                              this.props.className +
                              "-" +
                              index +
                              "-" +
                              heading.headingLabel
                            }
                            className="searchHeaderRows"
                          >
                            {index === 0
                              ? "Search Results for :" +
                                '"' +
                                this.props.searchText +
                                '"'
                              : ""}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableHead class="searchHeadersSecond">
                      <TableRow
                        key={this.props.className + "-searchHeaderSecondRow"}
                      >
                        {this.props?.config?.headings?.map((heading, index) => (
                          <TableCell
                            key={this.props.className + "-" + index}
                            className="searchHeadersSecondRows"
                          >
                            {index === 0
                              ? this.props.resultsCount +
                                " search results for " +
                                "[" +
                                this.props.searchType +
                                "]"
                              : ""}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                  </>
                ) : null}
                <TableHead
                  id={this.props.className + "-tablehead"}
                  className={
                    this.props?.tableMode == "light" ? "bg-light" : "bg-dark"
                  }
                >
                  {this.props?.config?.filters ? (
                    <TableRow
                      className={
                        this.state.filterValues?.length > 0
                          ? "columnFilters d-block"
                          : "d-none"
                      }
                    >
                      {/* <TableCell colSpan={this.props?.config?.headings?.length || 1} key={this.props.className + "-chips-0" } className="FW800" style ={{padding : "4px"}}  > */}

                      {/* </TableCell> */}
                    </TableRow>
                  ) : (
                    <></>
                  )}
                  <TableRow>
                    {this.props?.config?.headings?.map((heading, index) => (
                      <TableCell
                        key={this.props.className + "-" + index}
                        style={{ padding: "4px" }}
                        className={
                          this.props?.tableMode == "light"
                            ? "bg-light FW800"
                            : "bg-dark FW800"
                        }
                      >
                        <span
                          className="action-icon"
                          onClick={() =>
                            this.props?.sortCallback(heading.headingLabel)
                          }
                        >
                          <b>
                            {" "}
                            {heading.icon ? (
                              <div>
                                {heading.headingLabel}
                                <MDBIcon icon={heading.icon} />
                              </div>
                            ) : (
                              heading.headingLabel
                            )}{" "}
                          </b>
                        </span>
                      </TableCell>
                    ))}
                    {this.props?.config?.actions && (
                      <TableCell
                        key={
                          this.props.className +
                          "-" +
                          this.props?.config?.headings?.length
                        }
                        className={
                          this.props?.tableMode == "light"
                            ? "bg-light FW800"
                            : "bg-dark FW800"
                        }
                        style={{ padding: "4px" }}
                      ></TableCell>
                    )}
                  </TableRow>
                </TableHead>
                {this.props?.isLoading ? (
                  <div className="tableLoader">
                    <CircularProgress />
                  </div>
                ) : (
                  <TableBody key={this.props.className + "body"}>
                    {this.props?.list?.length > 0 &&
                      this.props?.list?.map((dataItem, rowIndex) => (
                        <TableRow
                          id={
                            this.props.className +
                            dataItem[this.props.config.primaryKey]
                          }
                          key={
                            this.props.className +
                            "-" +
                            dataItem[this.props.config.primaryKey] +
                            "-" +
                            rowIndex
                          }
                          onClick={
                            this.props?.flag
                              ? (e) => {
                                  this.props?.checking(e, dataItem, rowIndex);
                                }
                              : null
                          }
                        >
                          {this.props?.config?.dataNodes?.map((node, index) =>
                            ((node == "description") && (!dataItem["editing"]) && this.props?.config?.filtersLanding) ? (
                              <>
                                <TableCell className="FW800">
                                  <Tooltip title={dataItem["description"]} placement="left">
                                    <div className="table-desc-column">
                                      {dataItem["description"]}
                                    </div>
                                  </Tooltip>
                                </TableCell>
                              </>
                            ) : 
                            ((node == "subtotal_value") && this.props?.config?.tenantName?.[0]==="ContentAcquisition") ? (
                              <>
                              <TableCell className="FW800">
                                $
                              </TableCell>
                              </>
                            ) : 
                            ((node == "unit_cost") && (!dataItem["editing"]) && this.props?.config?.headings?.[index]?.headingLabel =="UNIT" && this.props?.config?.tenantName?.[0]==="ContentAcquisition") ? (
                              <>
                              <TableCell className="FW800">
                                {(dataItem["unit_cost"] ? dataItem["unit_cost"] : "") + (dataItem["unit_name"] ? "/" + dataItem["unit_name"] : "")}
                              </TableCell>
                              </>
                            ) :
                            ((node == "unit_id") && (!dataItem["editing"]) && this.props?.config?.tenantName?.[0]==="ContentAcquisition") ? (
                              <>
                              <TableCell className="FW800">
                              </TableCell>
                              </>
                            ) : 
                            ((node == "unit_cost") && (!dataItem["editing"]) && this.props?.config?.tenantName?.[0]==="ContentAcquisition") ? (
                              <>
                               <TableCell className="FW800">
                                  {(dataItem["unit_cost"] ? "$"+dataItem["unit_cost"] : "$ 0.00") }
                                </TableCell>
                              </>
                            ) : 
                            ((node == "purchase_subtotal_3") && (!dataItem["editing"]) && (this.props?.tableName==="exportPO" || this.props?.tableName==="contentAcquisitionDashboard")) ? (
                              <>
                              <TableCell className="FW800">
                                {`$${parseFloat(Number(parseFloat((dataItem?.["purchase_subtotal_3"]? Number(dataItem?.["purchase_subtotal_3"]?.split("$")?.[1]?.replace(/,/g, '')) : 0.00) + (dataItem["rush"]? Number(dataItem?.["rush"]) : 0.00))?.toFixed(2)))?.toFixed(2)}`}
                              </TableCell>
                              </>
                            ) :
                            ((node == "rush") && (!dataItem["editing"]) && (this.props?.tableName==="exportPO" || this.props?.tableName==="contentAcquisitionDashboard")) ? (
                              <>
                              <TableCell className="FW800">

                              </TableCell>
                              </>
                            ) :
                            node == "check" ? (
                              <TableCell className="FW800">
                                <input
                                  type="checkbox"
                                  checked={dataItem[node]}
                                  disabled={dataItem["is_avail"] == 0 || false}
                                  onClick={(event, newValue) => {
                                    dataItem[node] = event.target.checked;
                                    this.props.arrayCheckUncheck(
                                      event.target.checked,
                                      dataItem
                                    );
                                  }}
                                ></input>
                              </TableCell>
                            ) : (
                              <TableCell
                                key={
                                  this.props.className +
                                  "-" +
                                  dataItem[this.props?.config?.primaryKey] +
                                  "-" +
                                  dataItem[node] +
                                  "-" +
                                  index
                                }
                                className={
                                  (this.props?.config?.borders?.includes(node)
                                    ? "border-left-1-secondary "
                                    : "") +
                                  (this.props?.config?.changeColourToRed?.includes(
                                    dataItem[node]
                                  )
                                    ? "textColorRed "
                                    : "") +
                                  (this.props?.config?.changeColourToGreen?.includes(
                                    dataItem[node]
                                  )
                                    ? "textColorGreen "
                                    : "") +
                                  //(this.props?.config?.dataNodes.length == index+1 ? "border-right-0 " : ""  ) +
                                  "border-ver-1-secondary padding-5"
                                }
                              >
                                {dataItem["editing"] &&
                                this.props?.config?.inlineEdits?.some(
                                  (e) => e.dataNode === node
                                ) ? (
                                  <> </>
                                ) : node == "description" && (this.props?.config?.isHboTenant?.[0]==="HBO" || this.props?.config?.tenantName?.[0]==="ContentAcquisition") ? (
                                  dataItem[node] ? (
                                    <div className="overflow-auto" dangerouslySetInnerHTML={{ __html: dataItem[node] }} />
                                  ) : null
                                ) : node == "groups" ? (
                                  dataItem[node]?.map((item) => (
                                    <div className="groupsStyles">{item}</div>
                                  ))
                                ) : node == "label" ? (
                                  <div
                                    className="labelNames"
                                    onClick={(e) =>
                                      this.props.editData(dataItem, node)
                                    }
                                  >
                                    {dataItem[node]}
                                  </div>
                                ) : node == "title" ? (
                                  <div className="overflow-auto" dangerouslySetInnerHTML={{ __html: dataItem[node] }} />
                              ): this.props?.config?.hyperlinks?.includes(
                                    node
                                  ) ? (
                                  <a
                                    href="javascript:void(0);"
                                    onClick={(e) =>
                                      this.props.hyperLinkNavigationCallback(
                                        dataItem,
                                        node
                                      )
                                    }
                                  >
                                    {dataItem[node]}
                                  </a>
                                ) : // :
                                // this.props?.config?.inlineCheckbox?.includes(node) ?
                                //     (
                                //         <BasicCheckbox
                                //             id={"cb-" + dataItem[node]}
                                //             label={dataItem[node] || ""}
                                //             checked={this.state.listEdits?.[rowIndex]?.[dataItem[node]]}
                                //             className={"cb-" + dataItem[node]}
                                //             onChange={(e) => this.props?.handleInlineCheckboxEdit((e.target.checked ? true : false), dataItem)}
                                //         />
                                //     )
                                this.props?.config?.toggleFields?.includes(
                                    node
                                  ) ? (
                                  dataItem[node] != null ? (
                                    <MDBIcon
                                      icon={
                                        dataItem[node] == true
                                          ? "check"
                                          : "times"
                                      }
                                      className={
                                        dataItem[node] == true
                                          ? "text-success"
                                          : "text-dark"
                                      }
                                    />
                                  ) : (
                                    <> </>
                                  )
                                ) : this.props?.config?.nodeFields?.some(
                                    (configItem) => configItem.column === node
                                  ) ? (
                                  this.props?.config?.nodeFields?.map(
                                    (nodeItem) =>
                                      nodeItem.column === node ? (
                                        <MDBIcon
                                          icon={
                                            dataItem[node] !== 0
                                              ? nodeItem.icon
                                              : ""
                                          }
                                          onClick={
                                            nodeItem.column === "notes"
                                              ? this.props?.handlePopoverClick
                                              : nodeItem.icon === "flag"
                                              ? this.props?.handleFlagPopover
                                              : null
                                          }
                                        />
                                      ) : (
                                        <></>
                                      )
                                  )
                                ) : this.props?.config?.fileAttachments?.includes(
                                    node
                                  ) ? (
                                  <BasicButton
                                    variant="outlined"
                                    icon="paperclip"
                                    type="inline"
                                    inputType="file"
                                    id={
                                      this.props?.objectType +
                                      "-" +
                                      this.props?.name
                                    }
                                    uploadFile={this.props?.handleFileSelect}
                                  />
                                ) : this.state.selectOptionValues?.[node] &&
                                  !this.props?.config?.searchFields?.includes(
                                    node
                                  ) ? (
                                  <>{
                                    this.state.selectOptionValues?.[node].map(
                                      (item) => {
                                       if (item.value == dataItem[node]){
                                          return (
                                            <>
                                              {" "}
                                              {item?.label
                                                ? item.label
                                                : item.text}{" "}
                                            </>
                                          );
                                        }
                                      }
                                    )}
                                  </>
                                ) : this.props?.config?.searchFields?.includes(
                                    node
                                  ) ? (
                                  <>
                                    {this.props?.list?.map((item) => {
                                      if (item[node] == dataItem[node])
                                        return <>{item[node + "_name"]}</>;
                                    })}
                                  </>
                                ) : this.props?.config?.buttonFields?.some(
                                    (configItem) => configItem.column === node
                                  ) ? (
                                  this.props?.config?.buttonFields?.map(
                                    (nodeItem) =>
                                      nodeItem.column === node ? (
                                        <div className="buttonField-label">
                                          <BasicButton
                                            variant="contained"
                                            id={
                                              this.props?.objectType +
                                              "-" +
                                              this.props?.name
                                            }
                                            onClick={
                                              nodeItem.column === "eps"
                                                ? this.props
                                                    ?.handleClickEPSModal
                                                : nodeItem.column === "is_fr"
                                                ? () =>
                                                    this.props?.handleOnButtonClick(
                                                      dataItem
                                                    )
                                                : null
                                            }
                                            text={
                                              dataItem[node]
                                                ? dataItem[node]
                                                : nodeItem.column
                                            }
                                            icon={
                                              nodeItem.icon === ""
                                                ? ""
                                                : nodeItem.icon
                                            }
                                          />
                                        </div>
                                      ) : (
                                        <></>
                                      )
                                  )
                                ) : this.props?.config?.textWithbuttonFields?.some(
                                    (configItem) => configItem.column === node
                                  ) ? (
                                  this.props?.config?.textWithbuttonFields?.map(
                                    (nodeItem) =>
                                      nodeItem.column === node ? (
                                        <div style={{ display: "flex" }}>
                                          <span>{nodeItem.column}</span>
                                          <div className="buttonField-label">
                                            <BasicButton
                                              variant="contained"
                                              id={
                                                this.props?.objectType +
                                                "-" +
                                                this.props?.name
                                              }
                                              text={" "}
                                              icon={nodeItem.icon}
                                            />
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )
                                  )
                                ) : (
                                  <> {(node === 'item_no' && this.props.config.primaryKey[0]==='po_line_id') ? parseInt(rowIndex+1) : (node==='adj_curr_exch_rate' ? (dataItem[node] > 0 ? dataItem[node] : 1): dataItem[node])}</>
                                )}
                                {this.props?.config?.dataNodeGroups?.[node] ? (
                                  <>
                                    {this.props?.config?.dataNodeGroups?.[
                                      node
                                    ]?.map((item) =>
                                      dataItem["editing"] &&
                                      this.props?.config?.inlineEdits?.some(
                                        (e) => e.dataNode === item
                                      ) ? (
                                        <> </>
                                      ) : (
                                        <div>{dataItem[item]}</div>
                                      )
                                    )}
                                  </>
                                ) : (
                                  <> </>
                                )}

                                {dataItem["editing"] &&
                                this.props?.config?.inlineEdits?.some(
                                  (e) => e.dataNode === node
                                ) ? (
                                  <TableInlineEdits
                                    nodeName={node}
                                    headingLabel = {this.props?.config?.headings?.[index]?.headingLabel}
                                    placeholder={
                                      this.props?.config?.inlineEdits?.find(
                                        (e) => e.dataNode === node
                                      )?.placeholder
                                    }
                                    validateMethod={
                                      this.props?.config?.inlineEdits?.find(
                                        (e) => e.dataNode === node
                                      )?.validateMethod
                                    }
                                    inputType={this.getInputType(node)}
                                    inputValue={
                                      node==='adj_curr_exch_rate' ? 
                                     (this.state.listEdits?.[rowIndex]?.[node] > 0 ?this.state.listEdits?.[rowIndex]?.[node] : 1)
                                      :this.state.listEdits?.[rowIndex]?.[node] 
                                    }
                                    index={rowIndex}
                                    handleInlineEditChange={this.handleInlineEditChange.bind(
                                      this
                                    )}
                                    selectOptions={
                                      this.state.selectOptionValues?.[node]
                                    }
                                    searchString={this.props?.searchString}
                                    isMandatory={
                                      this.props?.config?.inlineEdits?.find(
                                        (e) => e.dataNode === node
                                      )?.isMandatory || false
                                    }
                                    showMandatory={
                                      this.props?.config?.inlineEdits?.find(
                                        (e) => e.dataNode === node
                                      )?.isMandatory || false
                                    }
                                  />
                                ) : (
                                  <> </>
                                )}

                                {this.props?.config?.dataNodeGroups?.[node] ? (
                                  <>
                                    {this.props?.config?.dataNodeGroups?.[
                                      node
                                    ]?.map((item) =>
                                      dataItem["editing"] &&
                                      this.props?.config?.inlineEdits?.some(
                                        (e) => e.dataNode === item
                                      ) ? (
                                        <TableInlineEdits
                                          nodeName={item}
                                          placeholder={
                                            this.props?.config?.inlineEdits?.find(
                                              (e) => e.dataNode === node
                                            )?.placeholder
                                          }
                                          validateMethod={
                                            this.props?.config?.inlineEdits?.find(
                                              (e) => e.dataNode === node
                                            )?.validateMethod
                                          }
                                          inputType={"text"}
                                          inputValue={
                                            this.state.listEdits?.[rowIndex]?.[
                                              item
                                            ]
                                          }
                                          index={rowIndex}
                                          handleInlineEditChange={this.handleInlineEditChange.bind(
                                            this
                                          )}
                                          searchString={
                                            this.props?.searchString
                                          }
                                        />
                                      ) : (
                                        <> </>
                                      )
                                    )}
                                  </>
                                ) : (
                                  <> </>
                                )}
                              </TableCell>
                            )
                          )}
                          {this.props?.config?.actions && (
                            <TableCell
                              key={this.props.className + "action"}
                              className={"border-ver-1-secondary"}
                            >
                              {" "}
                              <div className="row">
                                {
                                  // dataItem.add ?
                                  //     <div key={this.props.className}
                                  //         className="col-md padding-3">
                                  //         <MDBIcon
                                  //             icon={dataItem.add}
                                  //             className="action-icon"
                                  //         />
                                  //     </div> :
                                  this.props?.config?.actions?.map(
                                    (action, indexNo) => (
                                      <div
                                        key={
                                          this.props.className + "-" + indexNo
                                        }
                                        className="col-md padding-3"
                                        disabled={
                                          this.props?.tabValue === 1
                                            ? !dataItem?.is_edit
                                            : false
                                        }
                                        onMouseOver={(e) => {
                                          action === "info-circle"
                                            ? this.props?.handleOnHoverEnter(
                                                e,
                                                dataItem
                                              )
                                            : null;
                                        }}
                                        onMouseOut={(e) => {
                                          action === "info-circle"
                                            ? this.props?.handleOnHoverLeave(e)
                                            : null;
                                        }}
                                        onDoubleClick={(e) =>
                                          action === "file"
                                            ? this.props?.handleCommentBox(
                                                e,
                                                dataItem
                                              )
                                            : null
                                        }
                                        onClick={() =>
                                          action === "copy"? this.props?.handleInlineCopy(
                                            dataItem
                                          ):action === "pen"
                                            ? dataItem["editing"]
                                              ? this.props?.saveCallback(
                                                  this.state.listEdits,
                                                  rowIndex,
                                                  dataItem[
                                                    this.props.config.primaryKey
                                                  ],
                                                  dataItem
                                                )
                                              : this.props?.editCallback(
                                                  dataItem[
                                                    this.props.config.primaryKey
                                                  ],
                                                  dataItem
                                                )
                                            : action === "plus"
                                            ? this.props?.handleAddCallback(
                                                dataItem[
                                                  this.props.config.primaryKey
                                                ]
                                              )
                                            : action === "trash-alt" ||
                                              action === "times"
                                            ? this.props?.handleDelCallBack(
                                                dataItem[
                                                  this.props.config.primaryKey
                                                ],
                                                dataItem
                                              )
                                            : action === "arrows-alt-v"
                                            ? this.props?.handlepopupCallback(
                                                dataItem[
                                                  this.props.config.primaryKey
                                                ],
                                                dataItem
                                              )
                                            : action === "times"
                                            ? this.props?.handleInlineDelete(
                                                dataItem[
                                                  this.props.config.primaryKey
                                                ]
                                              )
                                            : null
                                        }
                                      >
                                        {action === "copy" ? (
                                          <Tooltip title={"Copy"} placement="left">
                                            <Button className="table-info-button">
                                              <MDBIcon
                                                icon={action}
                                                className="action-icon"
                                              />
                                            </Button>
                                          </Tooltip>
                                        ) : action === "trash-alt" ?
                                          <Tooltip title={"Delete"} placement="left">
                                            <Button className="table-info-button">
                                              <MDBIcon
                                                icon={action}
                                                className="action-icon"
                                              />
                                            </Button>
                                          </Tooltip>
                                        : action === "view" ? (
                                          <a href="#">{action}</a>
                                        ) : action === "pen" &&
                                          dataItem["editing"] ? (
                                          <Tooltip title={"Save"} placement="left">
                                            <Button className="table-info-button">
                                              <MDBIcon
                                                icon={"save"}
                                                color="primary"
                                                className="action-icon"
                                              />
                                            </Button>
                                          </Tooltip>
                                        ) 
                                        :
                                        action === "pen" &&
                                          !dataItem["editing"] ? (
                                          <Tooltip title={"Edit"} placement="left">
                                            <Button className="table-info-button">
                                              <MDBIcon
                                                icon={"pen"}
                                                color="primary"
                                                className="action-icon"
                                              />
                                            </Button>
                                          </Tooltip>
                                        ) 
                                        : action === "info-circle" ? (
                                          <Tooltip
                                            title={dataItem?.change_log?.map(
                                              (item) => {
                                                return (
                                                  <div>{item.change_log}</div>
                                                );
                                              }
                                            )}
                                            placement="left"
                                          >
                                            <Button className="table-info-button">
                                              <MDBIcon
                                                icon={action}
                                                className="action-icon"
                                              />
                                            </Button>
                                          </Tooltip>
                                        ) : action === "file" &&
                                          this.props?.showNotesTooltip ? (
                                          <Tooltip
                                            title={dataItem?.notes|| ""}
                                            placement="left"
                                          >
                                            <Button className="table-info-button">
                                              <MDBIcon
                                                icon={action}
                                                className="action-icon"
                                              />
                                            </Button>
                                          </Tooltip>
                                        ) 
                                        :(
                                          <>
                                           {this.props?.config?.showLoader && dataItem?.loadPdf ?
                                                <CircularProgress color="inherit" size={15} /> :
                                          <MDBIcon
                                            icon={action}
                                            className="action-icon"
                                            onClick={() =>
                                              typeof this.props.handleRowFileSelect === 'function' &&
                                              this.props?.handleRowFileSelect(
                                                dataItem,rowIndex 
                                              )                                           
                                            }
                                          />
                                           
                                             }
                                          </>
                                        )}
                                      </div>
                                    )
                                  )
                                }
                                {this.props?.config?.detailFields && (
                                  <div className="col-md padding-3">
                                    {this.renderLineDetailsButton(rowIndex)}
                                  </div>
                                )}
                              </div>
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    {this.props?.list?.length <= 0 && (
                      <TableRow>
                        <TableCell
                          className="text-align-center"
                          colSpan={this.props?.config?.headings?.length}
                        >
                          <b className="table-no-results">
                            {this.props?.customNoResultsMessage?.length > 0
                              ? this.props?.customNoResultsMessage
                              : "No Matching Results"}
                          </b>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </div>
          {this.props?.addItemToList && !this.props.isLoading ? (
        <> 
              {(this.props?.config?.isHboTenant?.[0]==="HBO" || this.props?.config?.tenantName?.[0]==="ContentAcquisition") &&
                <div className="inlineAdd borderBtm">
                  {this.props?.config?.showActionsItemBottom?.map((nodeItem, nodeIndex) => (
                    <div className="d-flex flex-column" style={{ width: nodeItem?.width ?? ""}}>
                    <div className={this.props?.userContext?.active_tenant?.tenant_id === 2?"d-flex justify-content-between":""}>
                     <div className={`f-75rem c-black bold pt-1`}>
                        {(nodeItem?.dataNode === 'actual_cost' || nodeItem?.dataNode === 'rush')? this.props?.userContext?.active_tenant?.tenant_id === 2? 'Estimated Cost: ' : 'Purchase Subtotal: ':""}
                        {(nodeItem?.dataNode === 'actual_cost' || nodeItem?.dataNode === 'rush') ? this.props?.userContext?.active_tenant?.tenant_id === 2 ? this.props?.currencySymbol+this.props?.totalCost : this.props?.totalCost : ''}
                      </div>
                      <div className={`f-75rem c-black bold ${(nodeItem?.dataNode === 'actual_cost' || nodeItem?.dataNode === 'rush') ? 'actualCostField' : ''}`}>
                      {(nodeItem?.dataNode === 'actual_cost' || nodeItem?.dataNode === 'rush') ? this.props?.userContext?.active_tenant?.tenant_id === 2 ? `Actual Cost: ${this.props?.currencySymbol}` : `Rush: ${this.props?.currencySymbol}` : ''}   
                      { (nodeItem?.dataNode === 'actual_cost' || nodeItem?.dataNode === 'rush')  &&
                      <TableInlineEdits
                  nodeName={nodeItem?.dataNode}
                  placeholder={nodeItem?.placeholder}
                  validateMethod={nodeItem?.validateMethod}
                  inputType={nodeItem?.inputType}
                 // inputValue={this.props.actualCost}
                  inputValue={this.state?.newItem?.[nodeItem?.dataNode]}
                  width={nodeItem.fieldWidth}
                  icon={nodeItem.icon}
                  index={nodeIndex}
                  handleInlineEditChange={this.onChangeNewItemHandler}
                  selectOptions={
                    this.state.selectOptionValues?.[nodeItem?.dataNode]
                  }
                  searchString={this.props?.searchString}
                  isMandatory={nodeItem.isMandatory || false}
                  showMandatory={
                    (nodeItem.isMandatory && this.props.showMandatory) || false
                  }
                />}
                    </div>
                     </div>
                      <div className={`f-75rem c-black bold`}>
                        {nodeItem?.dataNode === 'actual_cost' || nodeItem?.dataNode === 'rush' ? this.props?.userContext?.active_tenant?.tenant_id === 2 ? 'Commitments Left to Pay: ' : 'Purchase Total: ' : ''}
                        {nodeItem?.dataNode === 'actual_cost' || nodeItem?.dataNode === 'rush' ? this.props?.userContext?.active_tenant?.tenant_id === 2 ? `${this.props?.currencySymbol}${(this.props?.totalCost - this.props?.actualCost).toFixed(2)}` : `${this.props?.currencySymbol}${parseFloat(Number(parseFloat((this.props?.totalCost? Number(this.props?.totalCost?.split("$")?.[1]?.replace(/,/g, '')) : 0.00) + (this.props?.rush? Number(this.props?.rush.replace(/,/g, '')) : 0.00)).toFixed(2)))?.toFixed(2)}` : ''}
                      </div>
                  </div>
                ))}
              </div>
            }
        <div className={this.props?.userContext?.active_tenant?.tenant_id === 2? "inlineAdd borderBtm":"inlineAdd borderBtm tenant3"} id="table-buttoncolor">
              {this.props?.config?.inlineEdits?.map((nodeItem, nodeIndex) => (
                <TableInlineEdits
                  nodeName={nodeItem?.dataNode}
                  placeholder={nodeItem?.placeholder}
                  validateMethod={nodeItem?.validateMethod}
                  inputType={this.getInputType(nodeItem?.dataNode)}
                  inputValue={this.state?.newItem?.[nodeItem?.dataNode]}
                  width={nodeItem.width}
                  icon={nodeItem.icon}
                  index={nodeIndex}
                  handleInlineEditChange={this.onChangeNewItemHandler}
                  selectOptions={
                    this.state.selectOptionValues?.[nodeItem?.dataNode]
                  }
                  searchString={this.props?.searchString}
                  isMandatory={nodeItem.isMandatory || false}
                  showMandatory={
                    (nodeItem.isMandatory && this.props.showMandatory) || false
                  }
                />
              ))}
              {this.renderAddItemActions(<>
                {this.props?.config?.isHboTenant?.[0]==="HBO" ?
                <BasicButton
                  className="add-line-item-btn"
                  text="+ Line Item"
                  onClick={this.handleAddNewItem}
                /> :
                (this.props?.config?.tenantName?.[0]==="ContentAcquisition") || this.props?.config?.isUnitAdmin ?
                <BasicButton
                    text={(this.props?.config?.isHboTenant?.[0]==="HBO" || this.props?.config?.tenantName?.[0]==="ContentAcquisition")? "add line item" : "+ New" }
                    onClick={this.handleAddNewItem}
                  /> :
                <MDBIcon
                  icon={"plus-circle"}
                  onClick={this.handleAddNewItem}
                  className="table-newItem-btn"
                />
                }
              </>)}
              {this.props?.showClear && (
                <div className="clear-btn">
                  <BasicButton
                    variant="text"
                    text="Clear"
                    onClick={() => this.setState({ newItem: {} })}
                  />
                </div>
              )}
            </div>
             
              </>   
          ) : (
            ""
          )}
        </div>
        {this.props?.config?.detailFields && this.renderLineDetails()}
      </>
    );
  }
}

export default withUserContext(TableComponent);
